// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { IContactClaimsTeamInfoDto } from './IContactClaimsTeamInfoDto';
import {
    IContactClaimsTeamInfoDtoFromJSON,
    IContactClaimsTeamInfoDtoFromJSONTyped,
    IContactClaimsTeamInfoDtoToJSON,
    IContactClaimsTeamInfoDtoToJSONTyped,
} from './IContactClaimsTeamInfoDto';

/**
 * 
 * @export
 * @interface IContactInfoDto
 */
export interface IContactInfoDto {
    /**
     * 
     * @type {number}
     * @memberof IContactInfoDto
     */
    id?: number;
    /**
     * 
     * @type {number}
     * @memberof IContactInfoDto
     */
    organization_id?: number;
    /**
     * 
     * @type {string}
     * @memberof IContactInfoDto
     */
    org_path?: string;
    /**
     * 
     * @type {string}
     * @memberof IContactInfoDto
     */
    username?: string;
    /**
     * 
     * @type {string}
     * @memberof IContactInfoDto
     */
    role_name?: string;
    /**
     * 
     * @type {string}
     * @memberof IContactInfoDto
     * @deprecated
     */
    role?: string;
    /**
     * 
     * @type {number}
     * @memberof IContactInfoDto
     */
    role_id?: number;
    /**
     * 
     * @type {string}
     * @memberof IContactInfoDto
     */
    title?: string;
    /**
     * 
     * @type {string}
     * @memberof IContactInfoDto
     */
    first_name?: string;
    /**
     * 
     * @type {string}
     * @memberof IContactInfoDto
     */
    last_name?: string;
    /**
     * 
     * @type {string}
     * @memberof IContactInfoDto
     */
    email?: string;
    /**
     * 
     * @type {string}
     * @memberof IContactInfoDto
     */
    phone?: string;
    /**
     * 
     * @type {string}
     * @memberof IContactInfoDto
     */
    department?: string;
    /**
     * 
     * @type {boolean}
     * @memberof IContactInfoDto
     */
    primary?: boolean;
    /**
     * 
     * @type {string}
     * @memberof IContactInfoDto
     */
    external_identifier?: string;
    /**
     * 
     * @type {string}
     * @memberof IContactInfoDto
     */
    contact_type?: IContactInfoDtoContactTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof IContactInfoDto
     */
    contact_status_type?: IContactInfoDtoContactStatusTypeEnum;
    /**
     * 
     * @type {boolean}
     * @memberof IContactInfoDto
     */
    clock_in?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof IContactInfoDto
     */
    claims_assigned?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof IContactInfoDto
     */
    is_email_verified?: boolean;
    /**
     * 
     * @type {Array<string>}
     * @memberof IContactInfoDto
     */
    email_communication_type_list?: Array<IContactInfoDtoEmailCommunicationTypeListEnum>;
    /**
     * 
     * @type {Array<IContactClaimsTeamInfoDto>}
     * @memberof IContactInfoDto
     */
    claims_teams?: Array<IContactClaimsTeamInfoDto>;
    /**
     * 
     * @type {Set<string>}
     * @memberof IContactInfoDto
     */
    job_function_types?: Set<IContactInfoDtoJobFunctionTypesEnum>;
    /**
     * 
     * @type {Array<string>}
     * @memberof IContactInfoDto
     */
    permissions?: Array<string>;
}

/**
* @export
* @enum {string}
*/
export enum IContactInfoDtoContactTypeEnum {
    EMPLOYER = 'EMPLOYER',
    SYSTEM = 'SYSTEM'
}
/**
* @export
* @enum {string}
*/
export enum IContactInfoDtoContactStatusTypeEnum {
    ACTIVE = 'ACTIVE',
    DISABLED = 'DISABLED',
    PENDING = 'PENDING',
    EXPRESS_VERIFICATION = 'EXPRESS_VERIFICATION',
    EXPRESS_ORGANIZATION = 'EXPRESS_ORGANIZATION'
}
/**
* @export
* @enum {string}
*/
export enum IContactInfoDtoEmailCommunicationTypeListEnum {
    FINANCE = 'FINANCE',
    FILES = 'FILES',
    PLAN_MANAGEMENT = 'PLAN_MANAGEMENT',
    REPORTS = 'REPORTS'
}
/**
* @export
* @enum {string}
*/
export enum IContactInfoDtoJobFunctionTypesEnum {
    ACCOUNT_MANAGER = 'ACCOUNT_MANAGER'
}


/**
 * Check if a given object implements the IContactInfoDto interface.
 */
export function instanceOfIContactInfoDto(value: object): value is IContactInfoDto {
    return true;
}

export function IContactInfoDtoFromJSON(json: any): IContactInfoDto {
    return IContactInfoDtoFromJSONTyped(json, false);
}

export function IContactInfoDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IContactInfoDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'organization_id': json['organization_id'] == null ? undefined : json['organization_id'],
        'org_path': json['org_path'] == null ? undefined : json['org_path'],
        'username': json['username'] == null ? undefined : json['username'],
        'role_name': json['role_name'] == null ? undefined : json['role_name'],
        'role': json['role'] == null ? undefined : json['role'],
        'role_id': json['role_id'] == null ? undefined : json['role_id'],
        'title': json['title'] == null ? undefined : json['title'],
        'first_name': json['first_name'] == null ? undefined : json['first_name'],
        'last_name': json['last_name'] == null ? undefined : json['last_name'],
        'email': json['email'] == null ? undefined : json['email'],
        'phone': json['phone'] == null ? undefined : json['phone'],
        'department': json['department'] == null ? undefined : json['department'],
        'primary': json['primary'] == null ? undefined : json['primary'],
        'external_identifier': json['external_identifier'] == null ? undefined : json['external_identifier'],
        'contact_type': json['contact_type'] == null ? undefined : json['contact_type'],
        'contact_status_type': json['contact_status_type'] == null ? undefined : json['contact_status_type'],
        'clock_in': json['clock_in'] == null ? undefined : json['clock_in'],
        'claims_assigned': json['claims_assigned'] == null ? undefined : json['claims_assigned'],
        'is_email_verified': json['is_email_verified'] == null ? undefined : json['is_email_verified'],
        'email_communication_type_list': json['email_communication_type_list'] == null ? undefined : json['email_communication_type_list'],
        'claims_teams': json['claims_teams'] == null ? undefined : ((json['claims_teams'] as Array<any>).map(IContactClaimsTeamInfoDtoFromJSON)),
        'job_function_types': json['job_function_types'] == null ? undefined : new Set(json['job_function_types']),
        'permissions': json['permissions'] == null ? undefined : json['permissions'],
    };
}

export function IContactInfoDtoToJSON(json: any): IContactInfoDto {
    return IContactInfoDtoToJSONTyped(json, false);
}

export function IContactInfoDtoToJSONTyped(value?: IContactInfoDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'organization_id': value['organization_id'],
        'org_path': value['org_path'],
        'username': value['username'],
        'role_name': value['role_name'],
        'role': value['role'],
        'role_id': value['role_id'],
        'title': value['title'],
        'first_name': value['first_name'],
        'last_name': value['last_name'],
        'email': value['email'],
        'phone': value['phone'],
        'department': value['department'],
        'primary': value['primary'],
        'external_identifier': value['external_identifier'],
        'contact_type': value['contact_type'],
        'contact_status_type': value['contact_status_type'],
        'clock_in': value['clock_in'],
        'claims_assigned': value['claims_assigned'],
        'is_email_verified': value['is_email_verified'],
        'email_communication_type_list': value['email_communication_type_list'],
        'claims_teams': value['claims_teams'] == null ? undefined : ((value['claims_teams'] as Array<any>).map(IContactClaimsTeamInfoDtoToJSON)),
        'job_function_types': value['job_function_types'] == null ? undefined : Array.from(value['job_function_types'] as Set<any>),
        'permissions': value['permissions'],
    };
}

